module.exports = __webpack_public_path__ + "media/images/banner-personal-accident-insurance-1d3b24ced28cdfdca19938e08b04ca2d.jpg";